














































import { Component, Vue } from 'vue-property-decorator'
import TopProducts from '../components/products/TopProducts.vue'

import { BRow, BCol, BAlert, BIconTruck } from 'bootstrap-vue'

@Component({
  components: { BRow, BCol, TopProducts, BAlert, BIconTruck }
})
export default class HomePage extends Vue {
  public adBanners = {
    mainBanner: {
      source: 'https://cms-store.nyc3.cdn.digitaloceanspaces.com/CMS-cover.jpg',
      link: '#'
    },
    skinnyBanner: {
      source: 'https://cms-store.nyc3.cdn.digitaloceanspaces.com/newNewNew.jpg',
      link: '#'
    },
    regularBanner1: {
      source: 'https://cms-store.nyc3.cdn.digitaloceanspaces.com/pr8.jpeg',
      link: 'https://www.cmsalmacenes.com/portatil-hp-probook-440-g3-t1b43lt-993ed54d'
    },
    regularBanner2: {
      source: 'https://cms-store.nyc3.cdn.digitaloceanspaces.com/pr99.jpg',
      link: 'https://www.instagram.com/p/CCHBHPdpOfG/?utm_source=ig_web_button_share_sheet'
    },
    regularBanner3: {
      source: 'https://cms-store.nyc3.cdn.digitaloceanspaces.com/pr9.jpeg',
      link: 'https://www.cmsalmacenes.com/portatil-hp-probook-450-g6-6lm90lt-b859757a'
    },
    regularBanner4: {
      source: 'https://cms-store.nyc3.cdn.digitaloceanspaces.com/pr11.jpeg',
      link: 'https://www.cmsalmacenes.com/portatil-hp-probook-640-g5-48514813'
    }
  }
}
